import { Injectable } from '@angular/core';
import { config } from '@app/config/app';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor() {}

  base64Encode(str: string) {
    const bytes = new TextEncoder().encode(str);
    let binary = '';
    bytes.forEach((b) => (binary += String.fromCharCode(b)));
    return btoa(binary);
  }

  async encryptWithPublicKey(data: string): Promise<string> {
    try {
      const publicKeyPem = config.RSA_PUBLIC_KEY!;
      const encoder = new TextEncoder();
      const dataBuffer = encoder.encode(data);

      const publicKey = await this.importPublicKey(publicKeyPem);

      const encryptedBuffer = await window.crypto.subtle.encrypt(
        {
          name: 'RSA-OAEP',
        },
        publicKey,
        dataBuffer,
      );

      const encryptedString = this.arrayBufferToBase64(encryptedBuffer);
      return encryptedString;
    } catch (error) {
      console.error('Encryption failed:', error);
      throw error;
    }
  }

  private async importPublicKey(pem: string): Promise<CryptoKey> {
    const pemContents = pem
      .replace('-----BEGIN PUBLIC KEY-----', '')
      .replace('-----END PUBLIC KEY-----', '')
      .replace(/\s/g, '');

    const binaryDer = this.base64ToArrayBuffer(pemContents);

    return await window.crypto.subtle.importKey(
      'spki',
      binaryDer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      true,
      ['encrypt'],
    );
  }

  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}
